import { useContext, useReducer, useState } from "react";
import { HbrCancel, HbrMoreVert } from "../newComponents/Mycustomsvgicons";
import { AuthContext } from "../AuthContext";
import { actionConsts, reducer } from "../newComponents/StateManager";
import { CustomAlertDialog } from "../newComponents/CustomAlertDialog";
import { ConstVariables } from "./ConstantVariables";
import AxiosApi from "./AxiosApi";

const MyUploadedMessagesContent = ({title, preacher, description, videoUrl, thumbnail, url, genre, messageId, handleEditMessage, onMessageDeleted}) => {
    const [showMenu, setShowMenu] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const {user_email}= useContext(AuthContext);
       const [state,dispatch]=useReducer(reducer,{uploadProgress: "",progressIndicator: false, showAlert: false, 
        alertMessage: "",showOptionalDialog: false});

    const onEdit=()=>{
        handleEditMessage(title, preacher, description, videoUrl, thumbnail, url, genre, messageId);
        setShowMenu(false);
    };

    const deleteMessage=async()=>{
        setIsDeleting(true);
        const messageData = {
        messageId,
        user_email,
        thumbnail,
        url,
        api_key: process.env.REACT_APP_CONNECTERE_KEY,
        };
        try {
            const res = await AxiosApi.post("/deleteMessage", JSON.stringify(messageData),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: false
                }
            );
            dispatch({type: actionConsts.ALERT_MESSAGE, payload: res.data.success});
            dispatch({type: actionConsts.SHOWALERT, payload: true});
            setIsDeleting(false);
            onMessageDeleted();
        }catch (error) {
            if (!error?.response) {
                dispatch({type: actionConsts.ALERT_MESSAGE, payload: ConstVariables.NO_SERVER_RESPONSE});
                dispatch({type: actionConsts.SHOWALERT, payload: true});
            }else{
                dispatch({type: actionConsts.ALERT_MESSAGE, payload: error?.response.data.message});
                dispatch({type: actionConsts.SHOWALERT, payload: true});
            }
            setIsDeleting(false);
        }
    };

    const handleCloseAlert=(data)=>{
        if(data === "close"){
            dispatch({type: actionConsts.SHOWALERT, payload: false});
        }
    };


    return ( 
        <div className="my-uploaded-messages-content flex-column1" style={{borderRadius:"10px", backgroundColor:"333333"}}>
            <img src={thumbnail && thumbnail} alt="" />
            <div className="flex-spacearound" style={{width:"100%", position:"relative"}}>
                <h4 style={{color:"white", width: "90%"}}>{title}</h4>
                {showMenu ? 
                <HbrCancel width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>setShowMenu(false)}/>
                :
                <HbrMoreVert width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>setShowMenu(true)}/>
                }
                

                 {showMenu && 
                    <div className="my-uploaded-message-menu flex-column1" style={{position:"absolute", top:"100%", right:"0px", backgroundColor:"#333333", borderRadius:"10px", boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)", gap:"10px", padding:"10px", minWidth:"100px"}}>
                        <button className="buttonstyle" style={{color:"white", backgroundColor:"transparent"}} onClick={()=>onEdit()}>Edit</button>
                        <button className="buttonstyle" style={{color:"white", backgroundColor:"transparent"}} onClick={()=>deleteMessage()}>Delete</button>
                    </div>
                }
            </div>
            <p style={{color:"white"}}>{preacher}</p>

              {isDeleting && 
                    <div className="uploadshortsprogressinfo flex-column2">
                        <p style={{color: "white",fontWeight:"bold"}}>{state.uploadProgress}</p>
                        <div className="uploadshortspreloader">
                            <p style={{color: "white",fontWeight:"bold"}}>Deleting message ...</p>
                        </div>
                    </div>
                }
                {state.showAlert &&
                <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={handleCloseAlert} />
                }
        </div>
     );
}
export default MyUploadedMessagesContent;